const promptReview = {
  tableConfig: {
    comment: '更改分成比例时，若部分论文已送审到专家或接收单位，则已送审的论文管理费和专家评审费按照论文提交前的费用设置进行结算；未送审的论文可按照新的分成比例进行分成。'
  },
  queryList: [
    {
      name: 'auditYear',
      label: '年份',
      notNull: true,
      component: 'input'
    },
    {
      name: 'seasonName',
      label: '送审季度',
      notNull: true,
      component: 'input'
    },
    {
      name: 'schoolName',
      label: '送审学校',
      notNull: true,
      component: 'input'
    }
  ],
  urlMap: {
    select: {
      url: '/school/schoolBatch/listByPage',
      data: {
        sendType: '{default.sendType}'
      }
    },
    update: '/school/schoolDegreeOffice/saveOrUpdate',
    delete: '/school/schoolDegreeOffice/delete/{id}'
  },
  operList: [// 操作列表
  ],
  titles: [
    {
      name: 'auditYear',
      label: '年份',
      width: '100'
    },
    {
      name: 'seasonName',
      label: '送审季度',
      width: '100'
    },
    {
      name: 'name',
      label: '批次',
      width: '100'
    },
    {
      name: 'schoolName',
      label: '送审学校',
      width: '100'
    },
    {
      name: 'sendTypeName',
      label: '送审方式',
      width: '100'
    },
    {
      name: 'mManageFee',
      label: '硕士论文单篇管理费用',
      width: '200'
    },
    {
      name: 'mExpertFee',
      label: '硕士论文单篇专家评审费',
      width: '200'
    },
    {
      name: 'dManageFee',
      label: '博士论文单篇管理费用',
      width: '200'
    },
    {
      name: 'dExpertFee',
      label: '博士论文单篇专家评审费',
      width: '200'
    },
    {
      name: 'operation',
      label: '操作',
      width: '100',
      actionList: [
        {
          label: '修改',
          name: 'edit',
          width: 800,
          kind: 'primary', // error
          type: 'dialog', // request, router, dialog, func
          addr: 'customerThesis/feeManage?{default.sendType}_{id}'
        }
      ]
    }
  ]
}
export default promptReview



// WEBPACK FOOTER //
// ./src/layout/regularPage/config/customerThesis/feeManage.js